import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  // 时间戳转换
  timestampToTime(timestamp, type = 0) {
    if (timestamp === 0 || this.isEmpty(timestamp)) {
      return "暂无";
    }
    var date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
      date.getHours() < 10
        ? "0" + date.getHours() + ":"
        : date.getHours() + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    if (type === 0) {
      return Y + M + D + h + m + s;
    } else if (type === 1) {
      return h + m + s;
    } else if (type === 2) {
      return Y + M + D;
    }
  },
  deepClone(obj) {
    let cache = [];
    function clone(obj) {
      if (obj instanceof Object) {
        let cachedDist = findCache(obj);
        if (cachedDist) {
          return cachedDist;
        } else {
          let dist;
          if (obj instanceof Object) {
            if (obj instanceof Array) {
              dist = [];
            } else if (obj instanceof Function) {
              dist = function() {
                return obj.call(this, ...arguments);
              };
            } else if (obj instanceof RegExp) {
              dist = new RegExp(obj.obj, obj.flags);
            } else if (obj instanceof Date) {
              dist = new Date(obj);
            } else {
              dist = {};
            }
            cache.push([obj, dist]);
            for (let key in obj) {
              if (obj.hasOwnProperty(key)) {
                // 只复制不在原型上的属性
                dist[key] = clone(obj[key]);
              }
            }
            return dist;
          }
        }
      }
      return obj;
    }

    function findCache(obj) {
      for (let i = 0; i < cache.length; i++) {
        if (cache[i][0] === obj) {
          return cache[i][1];
        }
      }
    }
    return clone(obj);
  },

  // 判空
  isEmpty(string) {
    if (
      string === null ||
      string === undefined ||
      string === "" ||
      JSON.stringify(string) === "{}" ||
      JSON.stringify(string) === "[]"
    ) {
      return true;
    }
    return false;
  },
  // 返回传入时间戳的零点时间戳
  getDayStart(time) {
    return new Date(new Date(Number(time)).toLocaleDateString()).getTime();
  },
  // 返回传入时间戳的24点时间戳
  getDayEnd(time) {
    return this.getDayStart(Number(time)) + 24 * 60 * 60 * 1000 - 1;
  },
  // 判断是否是今天
  isToday(timestamp) {
    var todayString = new Date().toDateString();
    var paramString = new Date(timestamp).toDateString();
    return todayString === paramString;
  },
  // 判断是否是当前这个月
  isNowMonth(timestamp) {
    const now = new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth();
    const param = new Date(timestamp);
    const year = param.getFullYear();
    const month = param.getMonth();
    if (nowYear === year && nowMonth === month) {
      return true;
    } else {
      return false;
    }
  },
  // 隐藏手机号
  hidePhone(phoneNumber) {
    return phoneNumber.substr(0, 3) + "****" + phoneNumber.substr(7, 10);
  },
  // 转换后端给的枚举，因为后端除了机台预览那里是10进制，剩下基本都是二进制，需要转换。
  formatEnum(enumVal) {
    var binary = enumVal.toString(2);
    const length = binary.length;
    const enumArr = [];
    for (var i = 0; i < length; i++) {
      if (Number(binary[i]) === 1) {
        enumArr.push(length - 1 - i);
      }
    }
    return enumArr;
  },
  // 后端给我们的都是厘米，需要转换成米显示，我们传给后端的也要是厘米哦。
  toMeter(cm) {
    if (!this.isEmpty(cm) && !isNaN(Number(cm))) {
      return (Number(cm) / 100).toFixed(2);
    } else {
      return "";
    }
  },
  // 后端给我们的都是克，需要转换成千克显示，我们传给后端的也要是克哦
  toKg(k) {
    if (!this.isEmpty(k) && !isNaN(k)) {
      return (k / 1000).toFixed(2);
    } else {
      return "";
    }
  },
  // 秒转换成小时
  secondToHour(second) {
    return (second / 3600).toFixed(2);
  },
  // 毫秒转换成小时
  milliToHour(timestamp) {
    return (timestamp / 1000 / 3600).toFixed(2);
  },
  // 获取这个月开始的时间（第一天的0点）
  getFirstTimeByMonth(timeByMonth) {
    const clone = new Date(Number(timeByMonth));
    const year = clone.getFullYear();
    const month = clone.getMonth();
    const firstDate = new Date(year, month, 1);
    return firstDate.getTime();
  },
  // 获取这个月最后的时间(最后一天的24点)
  getLastTimeByMonth(timeByMonth) {
    const clone = new Date(Number(timeByMonth));
    const year = clone.getFullYear();
    const month = clone.getMonth() + 1;
    const lastDate = new Date(year, month, 0);
    return lastDate.getTime();
  },
  // 获取当前
  getNow() {
    const now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      date: now.getDate(),
      firstTimeByMonth: this.getFirstTimeByMonth(now.getTime()),
      lastTimeByMonth: this.getLastTimeByMonth(now.getTime()),
    };
  },
  getNowTime() {
    return new Date().getTime();
  },

// 要根据时间戳获取 “昨天是当月的第几天”，可以通过以下步骤实现：
// 将时间戳转换为 Date 对象
// 计算昨天的日期（当前日期减 1 天）
// 获取昨天的日期数字（即当月第几天）
    getYesterdayDate(timestamp) {
        // 创建时间戳对应的Date对象
        const date = new Date(timestamp);
        
        // 复制当前日期并减去1天（86400000毫秒 = 24小时）
        const yesterday = new Date(date);
        yesterday.setTime(yesterday.getTime() - 86400000);
        
        // 获取昨天的日期（当月第几天）
        return yesterday.getDate();
    },
  
  // 导出excel文件
  exportExcel(tableId, fileName = "MES工厂报表", fileType = "xlsx") {
    const fix = document.querySelector(".el-table__fixed");
    let wb;
    if (fix) {
      wb = XLSX.utils.table_to_book(
        document.querySelector(`#${tableId}`).removeChild(fix),
        { raw: true }
      );
      document.querySelector(`#${tableId}`).appendChild(fix);
    } else {
      wb = XLSX.utils.table_to_book(document.querySelector(`#${tableId}`), {
        raw: true,
      });
    }
    console.log(wb);
    var wbout = XLSX.write(wb, {
      bookType: fileType,
      bookSST: true,
      type: "array",
    });
    try {
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        `${fileName}.${fileType}`
      );
    } catch (e) {
      if (typeof console !== "undefined") console.log(e, wbout);
    }
    return wbout;
  },
  // 这个是数值大了，会出现精度问题。
  // 在新建生产单处调用
  formatDecimal(num, decimal = 2) {
    num = num.toString();
    const index = num.indexOf(".");
    if (index !== -1) {
      num = num.substring(0, decimal + index + 1);
    } else {
      num = num.substring(0);
    }
    return parseFloat(num).toFixed(decimal);
  },
  // 把指定的id在当前页面打印。
  print(id = "needPrint") {
    const newStr = document.getElementById(id).innerHTML;
    document.body.innerHTML = newStr;
    window.print();
    window.location.reload();
  },
  // 打印el-calendar 日历所用方法
  printPage(id = "needPrint") {
    // 空页面
    let printStr =
      "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'></head>";
    // 定义element-ui table组件的样式
    const tabStyle = `<style>
         .el-calendar {background-color: #fff;}
         .el-calendar__header {
          display: flex;justify-content: space-between;
          padding: 12px 20px;border-bottom: 1px solid #EBEEF5;}
         .el-calendar-table.thead {border-bottom: 1px;solid #EBEEF5;}
         .el-calendar__title {color: #000;align-self: center;}
         .el-calendar__button-group {display: none;}
         .el-calendar__body { padding: 12px 20px 35px}
         .el-calendar-table {table-layout: fixed;width: 100%;}
         .el-calendar-table th { border-bottom: 1px solid #EBEEF5; }
         .el-calendar-table tr td:first-child {border-left: 1px solid #EBEEF5;}
         .el-calendar-table td { border-bottom: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;
          vertical-align: top;transition: background-color .2s ease;}
         .el-calendar-table .el-calendar-day {box-sizing: border-box;padding: 0px;height: 95px;}
         .warning-value{background-color:orange}
         .el-calendar__title {font-size: 20px;color: #000;align-self: center;}
         </style><body>`;
    let content = "";
    var tableBody = "";

    // 获取名为传入id的 dom元素内的内容
    const str = document.getElementById(id).innerHTML;

    // 拼接空页面+style样式+dom内容
    content = content + str;
    printStr = printStr + tabStyle + content + "</body></html>";
    // 打开新页面
    const pwin = window.open("_blank");
    // 将内容赋值到新页面
    pwin.document.write(printStr);
    pwin.document.close();
    // 聚焦-不加focuse，在某些情况下，打印页面会有问题。
    pwin.focus();
    // 使用setTimeout，等页面dom元素渲染完成后再打印。
    setTimeout(() => {
      pwin.print(); // 打印功能。 例如 window.print() 直接打印当前整个页面。
      pwin.close();
      try {
        tableBody.border = "0";
      } catch (err) {}
    }, 500);
  },
  // 打印el-table 表格所用方法
  printTable(id = "needPrint", title = undefined) {
    let printStr =
      "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'></head>";
    const tabStyle = `<style>
      table.el-table__body {max-width: 1000px}
    </style><body>`;

    //var tableBody = document.getElementsByClassName('el-table__body')[0]
    //tableBody.border = '1'

    // 获取名为传入id的 dom元素内的内容
    const div = document.createElement("div");
    div.innerHTML = document.getElementById(id).innerHTML;
    //rzit-a-s
    let tableBody = div.querySelector(".el-table__body");
    tableBody.border = "1";
    //rzit-a-e
    // 将el-table 的header与body合二为一
    const ths = div.querySelectorAll(".el-table__header-wrapper th");
    const ThsTextArry = [];
    for (let i = 0, len = ths.length; i < len; i++) {
      if (ths[i].innerText !== "") ThsTextArry.push(ths[i].innerText);
    }
    // 删除多余的表头
    div.querySelector(".hidden-columns").remove();
    // 第一个表格的内容提取出来后已经没用了 删掉
    let oldheader = div.querySelector(".el-table__header-wrapper");
    if (oldheader) {
      oldheader.remove();
    }
    var newHeader = "<tr>";
    for (let i = 0, len = ThsTextArry.length; i < len; i++) {
      newHeader +=
        '<td style="text-align: center; font-weight: bold">' +
        ThsTextArry[i] +
        "</td>";
    }
    newHeader += "</tr>";
    div
      .querySelector(".el-table__body-wrapper table")
      .insertAdjacentHTML("afterbegin", newHeader);
    var titleHTML = "";
    if (title) {
      titleHTML = `<div style="text-align: center;font-size:30px;font-weight:bold">${title}</div>`;
    }
    //rzit-a-s: 删除右侧内容
    let fixedr = div.querySelector(".el-table__fixed-right");
    if (fixedr) {
      fixedr.remove();
    }
    //rzit-a-e
    printStr =
      printStr + tabStyle + titleHTML + div.innerHTML + "</body></html>";
    // 打开新页面
    const pwin = window.open("_blank");
    // 将内容赋值到新页面
    pwin.document.write(printStr);
    pwin.document.close();
    // 聚焦-不加focuse，在某些情况下，打印页面会有问题。
    pwin.focus();
    // 使用setTimeout，等页面dom元素渲染完成后再打印。
    setTimeout(() => {
      pwin.print(); // 打印功能。 例如 window.print() 直接打印当前整个页面。
      pwin.close();
      try {
        tableBody.border = "0";
      } catch (err) {}
    }, 500);
  },

  /**
   * add by hcy to print for any element with specified id
   * @param {} id
   * @param {*} title
   */
  printElement(id = "needPrint", title = undefined, style = "") {
    let printStr = `<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'>
    <style>${style}</style>
    </head><body>`;
    // 获取名为传入id的 dom元素内的内容
    const div = document.createElement("div");
    div.innerHTML = document.getElementById(id).innerHTML;
    printStr = printStr + div.innerHTML + "</body></html>";
    // 打开新页面
    const pwin = window.open("_blank");
    // 将内容赋值到新页面
    pwin.document.write(printStr);
    pwin.document.close();
    // 聚焦-不加focuse，在某些情况下，打印页面会有问题。
    pwin.focus();
    // 使用setTimeout，等页面dom元素渲染完成后再打印。
    setTimeout(() => {
      pwin.print(); // 打印功能。 例如 window.print() 直接打印当前整个页面。
      pwin.close();
      try {
        tableBody.border = "0";
      } catch (err) {}
    }, 500);
  },
};
